<template>
	<!-- 拒绝按钮 -->
	<div class="pointer plr-10 co-F52F3E">
		<div @click="Operate">{{ translate.ShowText('拒绝') }}</div>
	</div>
</template>

<script lang="ts" setup>
import translate from '@/api/translate';

const emits = defineEmits(["change"]);

const Operate = () => {
	emits("change");
}
</script>

<style lang="scss" scoped></style>